'use client';
import 'react';
import '@digdir/designsystemet-web';
export { RovingFocusItem, getNextFocusableValue, getPrevFocusableValue } from './roving-focus/roving-focus-item.js';
export { RovingFocusRoot } from './roving-focus/roving-focus-root.js';

const warn = (message, ...args) => typeof window === 'undefined' ||
    window.dsWarnings === false ||
    console.warn(`Designsystemet: ${message}`, ...args);

export { warn };
